import { render, staticRenderFns } from "./Func53.vue?vue&type=template&id=2c7020fa"
import script from "./Func53.vue?vue&type=script&lang=js"
export * from "./Func53.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports